import applyImageOperation from 'editor/src/store/editor/operation/applyImageOperation';
import addUploadedImagesOperation from 'editor/src/store/gallery/operation/addUploadedImagesOperation';
import getImageById from 'editor/src/store/gallery/selector/getImageById';
import type { AsyncThunk } from 'editor/src/store/hooks';

export interface CollectionFileToDesign {
  id: string;
  name?: string;
  url: string;
  thumbnailUrl?: string;
  width?: number;
  height?: number;
  mimeType?: string;
}

// Applies a single file picked from a Collection to the design the same way the Files tab does:
// it registers the file as a normal gallery (Files tab) asset from its existing URL — no re-upload —
// and places it on the canvas. This is intentionally NOT the personalization-layer flow
// (see addOrApplyCollectionFolderToPageOperation for that).
const addCollectionFileToDesignOperation =
  (file: CollectionFileToDesign): AsyncThunk =>
  async (dispatch, getState) => {
    if (!file?.id || !file?.url) {
      return;
    }

    const alreadyInGallery = !!getImageById(getState(), file.id);

    if (!alreadyInGallery) {
      await dispatch(
        addUploadedImagesOperation([
          {
            file: {
              id: file.id,
              name: file.name,
              type: file.mimeType,
              width: file.width,
              height: file.height,
              source: 'Collections',
            },
            url: file.url,
            thumbnailUrl: file.thumbnailUrl,
            mimeType: file.mimeType ?? '',
          },
        ]),
      );
    }

    dispatch(applyImageOperation({ imageId: file.id }));
  };

export default addCollectionFileToDesignOperation;
